import { BaseControlModel } from './base-control-model';

export class MeterControlModel extends BaseControlModel {
  public meter_name: string;
  public meter_address: string;
  public zone_id: string;

  // attributes for API version < 1.42
  public meter_value_t1: number;
  public meter_value_t1_units: string;
  public meter_value_t2: number;
  public meter_value_t2_units: string;
  public meter_consumption: number;
  public meter_consumption_units: string;

  // alternative attributes for API version < 1.42
  public t1: number;
  public t1_units: string;
  public t2: number;
  public t2_units: string;
  public consumption: number;
  public consumption_units: string;

  // attributes for API version >= 1.42
  public l1current: number;
  public l1current_units: string;
  public l1power: number;
  public l1power_units: string;
  public l1voltage: number;
  public l1voltage_units: string;
  public l2current: number;
  public l2current_units: string;
  public l2power: number;
  public l2power_units: string;
  public l2voltage: number;
  public l2voltage_units: string;
  public l3current: number;
  public l3current_units: string;
  public l3power: number;
  public l3power_units: string;
  public l3voltage: number;
  public l3voltage_units: string;
  public battery: number;
  public battery_units: string;
  public energy: number;
  public energy_units: string;
  public energytotal: number;
  public energytotal_units: string;
  public current: number;
  public current_units: string;
  public voltage: number;
  public voltage_units: string;
  public volume: number;
  public volume_units: string;
  public volume1: number;
  public volume1_units: string;
  public volume2: number;
  public volume2_units: string;
  public volumeflow: number;
  public volumeflow_units: string;
  public power: number;
  public power_units: string;
  public powerhz: number;
  public powerhz_units: string;
  public powertotal: number;
  public powertotal_units: string;
  public linkquality: number;
  public linkquality_units: string;
  public value_count: number;

  public override init() {
    super.init();
    this.name = this.meter_name;
  }
}
